module.exports = {
    name: 'Shreddy',
    logo: 'https://img.genflow.com/shreddy/checkout/logo.png',
    vendorUUID: '8caa4678-4871-4e9e-9f48-3847e2271454',
    metaData: {
        title: 'Shreddy',
        description: 'SHREDDY is the only app you need to achieve your transformation goals.',
        author: 'GENFLOW',
        url: 'https://www.shreddy.com/',
        image: 'https://img.genflow.com/shreddy/checkout/logo.png',
    },
    theme: {
        colors: {
            primary: '#A5CFEA',
            text: '#697386',
            ctaText: '#FFF27C',
        },
    },
    analytics: {
        gtag: '',
        facebookPixel: '517097062100071',
        tagManager: '',
        tapfiliate: '',
        // segment: '', - Stored in env
    },
    links: {
        terms: 'https://shreddy.com/pages/terms-and-conditions',
        privacy: 'https://shreddy.com/pages/privacy-policy',
        support: 'https://support.shreddy.com/hc/en-us',
        genflow: 'https://genflow.com',
        ios: 'https://apps.apple.com/app/shreddy/id1480771638',
        android: 'https://play.google.com/store/apps/details?id=com.bnd.shreddy',
    },
    forms: {
        errors: {
            existingUser: 'This user already exists, please login.',
            invalidPassword: 'The password needs to have 6 or more characters.',
            unknownError: 'The registration could not be processed.',
            userNotFound: 'Incorrect email/password combination',
        },
    },
    pages: {
        register: {
            title: 'Sign Up to',
            ctaText: 'Register',
            ctaLoadingText: 'Registering',
        },
        login: {
            title: 'Login to',
            ctaText: 'Login',
            ctaLoadingText: 'Logging In',

        },
    },
    products: [
        {
            title: '1 Month',
            product: '1month',
            label: null,
        }, {
            title: '3 Months',
            product: '3month',
        }, {
            title: '12 Months',
            product: '12month',
        },
    ],
};
